import React from 'react';

import { Menu as MuiMenu, styled } from '@mui/material';

import theme from '../../config/theme';

const Menu = styled(MuiMenu)(() => ({
  '& .MuiPaper-root': {
    background: theme.palette.primary.contrastText,
    color: 'white',
    [theme.breakpoints.down('lg')]: {
      '&>ul': {
        py: 0,
        padding: 0,
        '&>li': {
          minHeight: '33px',
          py: 0,
          lineHeight: 1.3,
        },
      },
      marginTop: '.3rem',
    },

    [theme.breakpoints.up('lg')]: {
      marginTop: '.1rem',
    },
  },
  zIndex: 10000,
}));

type PropTypes = {
  children: any;
  anchorElement: null | HTMLElement;
  handleClose: () => void;
  open: boolean;
  id: string;
};

export default function CustomMenu(props: PropTypes) {
  const { children, anchorElement, handleClose, open, id } = props;

  return (
    <Menu
      anchorEl={anchorElement}
      id={id}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      onClose={handleClose}
      open={open}
    >
      {children}
    </Menu>
  );
}
